// extracted by mini-css-extract-plugin
export default {"card":"card__OWNjN","hed":"hed__NzVkZ","note":"note__ODE5M","link":"link__ODVkM"};